import React from 'react';

const MenuFilterButton = (props) => {
  const {
    currentFilters,
    currentOption,
    onClick,
    value,
    className,
    text,
    ...restProps
  } = props;
  return (
    <button
      onClick={onClick}
      value={text}
      className={`${
        className ? className : ''
      } tw-border-2 tw-p-2 tw-bg-white tw-border-black tw-transition tw-duration-250 tw-ease-in ${
        currentFilters && currentFilters[currentOption].includes(text)
          ? 'filter-btn-active'
          : ''
      }`}
      {...restProps}
    >
      {text}
    </button>
  );
};

export default MenuFilterButton;
